import { render, staticRenderFns } from "./BannerHeaderMobile.vue?vue&type=template&id=0f1b2dca&"
import script from "./BannerHeaderMobile.vue?vue&type=script&lang=ts&"
export * from "./BannerHeaderMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports